import { createSearchParamsContext } from 'src/app/shared/contexts/SearchParamsContext'

// Create Client Setup search params context
const { Provider, useContext } = createSearchParamsContext(
  'bfa_client_setup_search_params',
  'ClientSetupFilters'
)

export const ClientSetupFiltersProvider = Provider
export const useClientSetupFilters = useContext